export default {
  errors: (state) => state.errors,
  error_msg: (state) => state.error_msg,
};
